<script>
import TrackModal from "@/components/modals/track-modal.vue";
import Details from "@/components/widgets/document-tracking-details";
import CreateDetails from "@/router/views/dts/dts-modal/details";
import PrintOptions from "@/components/modals/print-options.vue";

export default {
  name: "DocumentTracking",
  components: {
    Details,
    CreateDetails,
    PrintOptions,
    TrackModal
  },
  data() {
    return {
      referenceNumber: "",
      officeIncomingCount: 0,
      departmentIncomingCount: 0,
      modalTitle: "",
      processTypeOptions: [],
      actionTypeOptions: [],
      formLoading: false,
      campusId: this.$store.state.data.selectedCampus.id,
      selectedDU: this.$store.state.data.selectedDU,
      selectedDepartment: this.$store.state.data.selectedDepartment,
      sendAsOptions: [
        { text: 'Office', value: 'office' },
        { text: 'Department', value: 'department' }
      ],
      selectedSendAs: 'office',
    };
  },
  methods: {
    getTrack() {
      if (this.referenceNumber == "") {
        this.showToast("Invalid tracking number.", "warning");
        return;
      }
      this.$store
        .dispatch("dtstrack/GetTrackByReferenceNumber", {
          deliveryUnitId: this.$store.state.data.selectedDU.id,
          stringData: this.referenceNumber.trim(),
        })
        .then((res) => {
          this.viewDetails(res.data);
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Invalid tracking number.", "warning");
          } else {
            this.showToast("Something went wrong - Getting track!", "error");
          }
        });
    },
    setCount(officeIncomingCount, departmentIncomingCount) {
      this.officeIncomingCount = officeIncomingCount;
      this.departmentIncomingCount = departmentIncomingCount;
    },
    viewDetails(props) {
      this.$refs.details.getData(props);
    },
    async uploadToServer(data){
        try{
          let response = await this.$store.dispatch("filemanager/UploadFile", data);
          if (response.data.error) {
            return { error: true, message: response.data.errorMessage };
          }
          return { error: false, data: response.data };
        }catch(e){
          return { error: true, message: "Something went wrong" };
        }
    },
    async uploadAttachments(files, trackNo){
      let errorDetails = [];
      for await(const file of files){
        file.id = trackNo;
        let response = await this.uploadToServer(file);
        if(response.error){
          file.error = true;
          file.errorMessage = response.message;
          errorDetails.push(file);
        }
      }
      if(errorDetails.length) {
        this.showToast("Some files were not uploaded. Please try again.", "error");
      }
    },
    onSubmit(modalData) {
      if (this.selectedSendAs === 'department') {
        modalData.departmentId = this.selectedDepartment.id;
      } else {
        modalData.departmentId = 0; // 0 means send as office
      }

      if (modalData.actionType.type != "Others") {
        modalData.actionNeeded = modalData.actionType.type;
      }
      this.$store
        .dispatch("dtstrack/CreateTrack", modalData)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          if (modalData.tracks.length > 0) {
            var newTrack = res.data;
            this.$store
              .dispatch("dtstrack/MergeTrack", {
                parentId: newTrack.id,
                array: modalData.tracks
              })
              .then((res) => {
                if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
                }
                if (modalData.sendType == "send") {
                  this.$store
                    .dispatch("dtstrack/PostTrack", newTrack.id)
                    .then((res) => {
                      if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                      }
                      let dashboardData = JSON.parse(
                        localStorage.getItem("dashboardData")
                      );
                      dashboardData.incomingTracks =
                        dashboardData.incomingTracks + 1;
                      localStorage.setItem(
                        "dashboardData",
                        JSON.stringify(dashboardData)
                      );
                      this.$refs.createDetails.getData(newTrack.id);
                    })
                    .catch((err) => {
                      this.showToast("Cannot be sent!", "error");
                    });
                }
                this.$bvModal.hide("modal-documentTrack");
                this.showToast("Successfully created!", "success");
              });
          } else {
            if (modalData.sendType == "send") {
              this.$store
                .dispatch("dtstrack/PostTrack", res.data.id)
                .then((res) => {
                  if (res.data.error) {
                    return this.showToast(res.data.errorMessage, "error");
                  }
                  let dashboardData = JSON.parse(
                    localStorage.getItem("dashboardData")
                  );
                  dashboardData.incomingTracks =
                    dashboardData.incomingTracks + 1;
                  localStorage.setItem(
                    "dashboardData",
                    JSON.stringify(dashboardData)
                  );
                  this.$refs.createDetails.getData(res.data.id);
                })
                .catch((err) => {
                  this.showToast("Cannot be sent!", "error");
                });
            }
            this.$bvModal.hide("modal-documentTrack");
            this.showToast("Successfully created!", "success");
          }
          if(modalData.attachments.length){
            this.uploadAttachments(modalData.attachments, res.data.id);
          }
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async createTrack() {
      this.$refs.trackModal.loading = true;
      this.modalTitle = "Create Track";
      this.$refs.trackModal.onReset();
      this.$bvModal.show("modal-documentTrack");
      await this.getProcessType();
      await this.getActionType();
      this.$refs.trackModal.loading = false;
    },
    async getDocuments(props) {
      this.$store
        .dispatch("dtstrackdocument/GetTrackDocument", props.id)
        .then((res) => {
          for (var count = 0; count < res.data.length; count++) {
            props.documents.push(res.data[count].title);
          }
        });
    },
    async getProcessType() {
      await this.$store.dispatch("dtsprocesstype/GetProcessType").then((res) => {
        this.processTypeOptions = res.data.sort(function (a, b) {
          if (a.processName < b.processName) {
            return -1;
          }
          if (a.processName > b.processName) {
            return 1;
          }
          return 0;
        });
      });
    },
    async getActionType() {
      await this.$store.dispatch("dtsactiontype/GetActionType").then((res) => {
        this.actionTypeOptions = res.data.sort(function (a, b) {
          if (a.type < b.type) {
            return -1;
          }
          if (a.type > b.type) {
            return 1;
          }
          return 0;
        });
        this.actionTypeOptions.push({ type: "Others" });
      });
    },
    async refreshOptions() {
      this.$refs.trackModal.setLoading(true);
      await this.getProcessType();
      await this.getActionType();
      this.$refs.trackModal.setLoading(false);
    },

    async updateTrack(props) {
      this.formLoading = true;
      this.modalTitle = "Update Track";
      this.$bvModal.show("modal-documentTrack");
      this.$refs.trackModal.updateData(props);
    },
    deleteTrack(props) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtstrack/DeleteTrack", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var index = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(index, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    postTrack(props) {
      this.$swal({
        title: "Are you sure?",
        text: "You are about to send this track.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, send it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtstrack/PostTrack", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let dashboardData = JSON.parse(localStorage.getItem("dashboardData"));
              dashboardData.incomingTracks = dashboardData.incomingTracks + 1;
              if (props.status == "RETURNED") {
                dashboardData.returnedTracks = dashboardData.returnedTracks - 1;
              }
              localStorage.setItem("dashboardData", JSON.stringify(dashboardData));
              this.$refs.createDetails.getData(res.data.id);
              var index = this.tableData.findIndex((item) => item.id == props.id);
              this.tableData.splice(index, 1);
              this.showToast("Successfully sent", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be sent!", "error");
            });
        }
      });
    },
    unsendTrack(props) {
      this.$swal({
        position: "top",
        title: "Are you sure?",
        text: "You are about to unsend this track.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ff9f43",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, unsend track!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtstrack/UnsendTrack", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.showToast("Successfully unsent", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be unsent!", "error");
            });
        }
      });
    },
    async printSingleTrackingReport(id) {
      var apiUrl = `dts/api/Report/Tracking`;
      var routeVariables = [];
      var body = [];
      body.push({ id: id });
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: body
      });
      this.$bvModal.show("print-options-modal");
    }
  },
};
</script>

<template>
  <div>
    <TrackModal 
      ref="trackModal"
      :modalTitle="modalTitle"
      :sendAsOptions="sendAsOptions"
      :selectedSendAs="selectedSendAs"
      :processTypeOptions="processTypeOptions"
      :actionTypeOptions="actionTypeOptions"
      @refreshOptions="refreshOptions" 
      @submit="onSubmit"
    />

    <!-- Process Tracking Card -->
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h4 class="card-title mb-0">Process Tracking</h4>
          <button type="button" @click="createTrack()" class="btn btn-sm btn-success d-inline-flex align-items-center">
            <i class="bx bx-plus fs-6 me-1"></i>Create Track
          </button>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex gap-3">
              <router-link id="officeTracks" v-if="selectedDU.withDeliveryUnitAccess || $store.state.decrypt.isAdmin()"
                to="/dts/incoming-tracks" class="border border-r-5px py-2 px-3 text-decoration-none position-relative"
                style="flex: 1; transition: all 0.2s ease;"
                onmouseover="this.classList.add('shadow-lg'); this.querySelector('.track-number').classList.add('text-info'); this.querySelector('.track-number').classList.remove('text-muted'); this.querySelector('p').classList.add('text-info'); this.querySelector('p').classList.remove('text-muted'); this.style.borderColor='#50a5f1';"
                onmouseout="this.classList.remove('shadow-lg'); this.querySelector('.track-number').classList.remove('text-info'); this.querySelector('.track-number').classList.add('text-muted'); this.querySelector('p').classList.remove('text-info'); this.querySelector('p').classList.add('text-muted'); this.style.borderColor='';">
                <div class="text-center">
                  <h5 class="font-size-15 track-number text-muted mb-1">{{ officeIncomingCount }}</h5>
                  <p class="text-muted small mb-0">Office Tracks</p>
                </div>
              </router-link>

              <router-link to="/dts/dept-incoming-tracks"
                class="border border-r-5px py-2 px-3 text-decoration-none position-relative"
                style="flex: 1; transition: all 0.2s ease;"
                onmouseover="this.classList.add('shadow-lg'); this.querySelector('.track-number').classList.add('text-info'); this.querySelector('.track-number').classList.remove('text-muted'); this.querySelector('p').classList.add('text-info'); this.querySelector('p').classList.remove('text-muted'); this.style.borderColor='#50a5f1';"
                onmouseout="this.classList.remove('shadow-lg'); this.querySelector('.track-number').classList.remove('text-info'); this.querySelector('.track-number').classList.add('text-muted'); this.querySelector('p').classList.remove('text-info'); this.querySelector('p').classList.add('text-muted'); this.style.borderColor='';">
                <div class="text-center">
                  <h5 class="font-size-15 track-number text-muted mb-1">{{ departmentIncomingCount }}</h5>
                  <p class="text-muted small mb-0">Department Tracks</p>
                </div>
              </router-link>
            </div>
          </div>
        </div>

        <div>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="text-muted">Track Search</span>
          </div>
          <div class="input-group">
            <input autocomplete="off" type="text" class="form-control" placeholder="Input Tracking Number..."
              v-model="referenceNumber" v-on:keyup.enter="getTrack" />
            <button type="button" @click="getTrack" class="btn btn-primary">
              <i class="bx bx-search fs-6 me-1"></i>Get Track
            </button>
          </div>
          <p class="text-muted mb-0 mt-1">
            <small><i class="bx bx-info-circle me-1"></i>Enter a valid tracking number to search</small>
          </p>
        </div>
      </div>
    </div>
    <Details ref="details"></Details>
    <CreateDetails user="office" @updateTrack="updateTrack($event)" @postTrack="postTrack($event)"
      @unsendTrack="unsendTrack($event)" @deleteTrack="deleteTrack($event)"
      @printTrackingReport="printSingleTrackingReport($event)" ref="createDetails"></CreateDetails>
    <print-options ref="printOpt"></print-options>
  </div>
</template>